import React from 'react'
import {_AccordionButton} from "./_AccordionButton";
import Accordion from "react-bootstrap/Accordion";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import {useSelector} from "react-redux";
import {Loading} from "../../../ui/loading/Loading";
import {zynity_api} from "../../../../config/external-routes";
import {_Comments} from "./_Comments";
import {_SubDatum} from "./_SubDatum";

export const DatumAccordionItem = ({datum, total_coach_notes, handleEditItem, handleDeleteItem, handleAddComment, handleEditComment, handleChangeListOrder, handleOpenReminder, isSubItem, clickNewItem, readOnly, subdatumModalOpenKey, handleArchiveItem, handleActiveItem, handleMarkPrivateItem, handleMarKNotificationsAsRead}:any) => {
    const team_obj = useSelector((state: any) => state.organization_team);
    const a = moment();
    const b = moment(datum.dateCreated);
    const days = a.diff(b, 'days')

    if(team_obj.isLoading === true) {
        return <Loading />;
    }

    const getAuthorKnowAs = (people_id: number) => {
        let author = team_obj?.data?.members?.find((member: { id: number; }) => (member.id === people_id))
        if(author === undefined) {
            return 'Not Found';
        }

        return author.KnownAs;
    }

    const getAuthorInitials = (people_id: number) => {
        let author = team_obj?.data?.members?.find((member: { id: number; }) => (member.id === people_id))
        if(author === undefined) {
            return '--';
        }

        return `${author.FirstName.substring(0, 1)}${author.LastName.substring(0, 1)}`;
    }

    return (
        <Accordion.Item className='mt-2' eventKey={datum.id.toString()} style={{backgroundColor: '#FDF68C', color: 'black', borderColor: '#9b9b9b'}}>
            <_AccordionButton eventKey={datum.id.toString()} coach_note={datum} total_coach_notes={total_coach_notes}
                              handleEditItem={handleEditItem} handleDeleteItem={handleDeleteItem}
                              handleAddComment={handleAddComment} handleChangeListOrder={handleChangeListOrder}
                              handleArchiveItem={handleArchiveItem}
                              handleMarkPrivateItem={handleMarkPrivateItem}
                              handleMarKNotificationsAsRead={handleMarKNotificationsAsRead}
                              handleActiveItem={handleActiveItem}
                              readOnly={readOnly}
                              isSubItem={isSubItem}
                              handleOpenReminder={handleOpenReminder}>{datum.title}</_AccordionButton>
            <Accordion.Body style={{backgroundColor: 'white'}}>
                <div className="row">
                    <div className="col-3 col-md-2 col-lg-1 p-0 border-right">Story</div>
                    <div className="col-9 col-md-10 col-lg-11" dangerouslySetInnerHTML={{__html: datum.description}}/>

                    <div className="col-12 mt-1 mb-1 p-1" style={{backgroundColor: '#F1F1F1'}}>
                        <span className='mx-3'><span className='text-muted'>Created: </span>{moment(datum.dateCreated).format('DD MMM YYYY')}</span>
                        <span className='mx-3'><span className='text-muted'>Last Edit: </span>{moment(datum.lastModified).format('DD MMM YYYY')}</span>
                        <span className='mx-3'><span className='text-muted'>Open: </span>+{days} days</span>
                    </div>

                    {
                        datum.links.length > 0 &&
                        <>
                            <div className="col-3 col-md-2 col-lg-1 p-0 border-right mt-1">Links</div>
                            <div className="col-9 col-md-10 col-lg-11 mt-1">
                                {
                                    datum.links.map((link: { links: string; }) => (
                                        <div><a className='color-teal' href={link.links} target='_blank'>{link.links}</a></div>
                                    ))
                                }
                            </div>

                            <hr className='mt-2' style={{border: 0, borderTop: '1px solid #d1d1d1'}}/>
                        </>
                    }

                    {
                        datum.uploads.length > 0 &&
                        <>
                            <div className="col-3 col-md-2 col-lg-1 p-0 border-right mt-1">Uploads</div>
                            <div className="col-9 col-md-10 col-lg-11 mt-1">
                                {
                                    datum.uploads.map((uploads: {
                                        displayName: any;
                                        fileName: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal; }) => (
                                        <div><a className='color-teal' href={`${zynity_api.global_download_files}?path=${uploads.fileName}&force_download=true`}>{uploads.displayName}</a></div>
                                    ))
                                }
                            </div>

                            <hr className='mt-2' style={{border: 0, borderTop: '1px solid #d1d1d1'}}/>
                        </>
                    }

                    <_Comments datum={datum} handleAddComment={handleAddComment} handleEditComment={handleEditComment} />

                    {
                        isSubItem === false &&
                        <_SubDatum
                            datum={datum}
                            clickEditItem={handleEditItem}
                            clickAddComment={handleAddComment}
                            handleChangeListOrder={handleChangeListOrder}
                            handleOpenReminder={handleOpenReminder}
                            clickEditComment={handleEditComment}
                            clickDeleteItem={handleDeleteItem}
                            clickNewItem={clickNewItem}
                            handleArchiveItem={handleArchiveItem}
                            handleActiveItem={handleActiveItem}
                            handleMarKNotificationsAsRead={handleMarKNotificationsAsRead}
                            readOnly={readOnly}
                            subdatumModalOpenKey={subdatumModalOpenKey}
                        />
                    }

                </div>
            </Accordion.Body>
        </Accordion.Item>
    )
}
